<template>
  <div
    class="gx-orb"
    :class="{ 'gx-orb--fixed': fixed }"
    :style="{
      left: x,
      top: y,
      width: size + 'px',
      height: size + 'px',
      background: `radial-gradient(circle, ${color} 0%, transparent 68%)`,
      opacity: op
    }"
  ></div>
</template>

<script>
export default {
  name: 'GlowOrb',
  props: {
    color: { type: String, default: 'rgba(212,169,70,.4)' },
    size: { type: Number, default: 400 },
    x: { type: String, default: '50%' },
    y: { type: String, default: '50%' },
    op: { type: Number, default: 0.08 },
    fixed: { type: Boolean, default: false }
  }
}
</script>

<style scoped>
.gx-orb {
  position: absolute;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  pointer-events: none;
  animation: gx-orbDrift var(--gx-member-orb-duration, 14s) var(--gx-member-ease, ease-in-out) infinite;
  z-index: 0;
}
.gx-orb--fixed {
  position: fixed;
}
</style>
